// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad41ac1f","455":"c9ff8c72","977":"6231c9dc"}[chunkId] + ".chunk.js";
};